/* eslint-disable no-console */
<template>
    <div class="main_unit">
        <div class="store_login_unit_manage_menu">CSV出力管理者画面</div>
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div class="store_List_tbl_unit wd976 tbl_ht_none tbl_bg_blue" v-show="!isInitLoading">

            <Message v-if="apiValidationMessage" :validationMessage="apiValidationMessage" />

            <div class="input_companyBrand left_comment ">
                <div>
                    <label for="company" style="padding-right: 20px;">企業</label>
                    <select id="company" v-model="companySelectValue" class="wd400" @change="changeCompany" >
                        <option value=null disabled>企業を選択</option>
                        <option v-for="companyList in companyLists" :key="companyList" :value="companyList.id">
                            {{companyList.companyName}} {{companyList.brandName}}</option>
                    </select><br>
                </div>
            </div>

            <table>
                <tbody>
                <tr class="text-center">
                    <th class="wd240 border_bottom_none" style="min-width:240px" v-for="(value,key) in columns" :key="key" @click="sortBy(key)">
                        {{value}}
                        <img class="triangle" v-if="sortOrders[key] > 0" src="../assets/img/UnderTriangleWhite.png" width="15px" height="13px" alt="UnderTriangle">
                        <img class="triangle" v-if="sortOrders[key] <= 0" src="../assets/img/UpTriangleWhite.png" width="15px" height="13px" alt="UpTriangle">
                    </th>
                    <th class="wd495" style="min-width:495px" rowspan="2">店舗住所</th>
                    <th v-if="auth == 5" class="wd240" style="min-width:240px" rowspan="2">解約</th>
                </tr>
                <tr>
                    <th class="border_top_none"><input class="wd150" type="text" v-model="searchWord" placeholder="キーワード検索"> </th>
                </tr>
                <tr v-for="storeList in filteredDatas" :key="storeList.brandId">
                    <td class="text_white_space" v-for="(value,key) in columns" :key="key">
                        {{storeList[key]}}
                    </td>
                    <td class="text_white_space">{{storeList.address}}</td>
                    <td v-if="storeList.cancellationFlg ==0" class="store_buttan_unit staff_kanri_box">
                        <ul class="ul_tbl_buttan">
                            <li><a class="staff_buttan_unit " href="#" @click.prevent.stop="openModel(storeList.id, storeList.storeId, storeList.storeName)">解約</a></li>
                        </ul>
                    </td>
                    <td v-else class="lavel_cansel_align">
                        <div style = "padding: 16px;">
                            <label v-if="storeList.cancellationFlg ==1" class="lavel_cansel_font">解約済(SEM)</label>
                            <label v-if="storeList.cancellationFlg ==2" class="lavel_cansel_font">解約済(HRD)</label>
                            <br>
                            <label class="lavel_cansel_font">{{storeList.updatedDatetime}}</label>
                        </div>
                    </td>
                </tr>
                </tbody>

            </table>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">店舗解約</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>以下の店舗に対して解約処理を実施します<br>
                            本当によろしいですか？<br><br>
                            企業名：{{this.delCompanyName}}<br>
                            ブランド名：{{this.delBrandName}}<br>
                            店舗名：{{this.delStoreName}}<br>
                        </p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a href="#" @click.prevent.stop="closeModel">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="canModel">解約</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent2">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">店舗解約</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>店舗の解約が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel2">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
        <div class="overlay_loder2" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    export default {
        name: 'StoreCancelList',
        components: {
            PulseLoader
        },
        data: function () {
            var columns = {
                storeName :"店舗名",
            };
            var sortOrders = {};
            Object.keys(columns).forEach(function (key) {
                sortOrders[key] = 1
            });
            return {
                isInitLoading:true,
                brandId: '',
                storeId: '',
                auth:'',
                columns:columns,
                sortKey:'',
                sortOrders:sortOrders,
                searchWord:'',
                storeContent: [],
                isLoading: false,
                apiValidationMessage: "",
                csvResponseData: [],
                showContent: false,
                companyLists:null,
                companySelectValue:null,
                storeLists:null,
                delId: null,
                delCompanyName: "",
                delBrandName: "",
                delStoreName: null,
                showContent2: false,
            }
        },
        created: function(){
            this.calc();
        },
        methods:{
            async calc(){
                //ブランドIDを取得
                this.brandId = this.$store.getters['manager/manager'].brandId;
                //権限情報を取得
                this.auth = this.$store.getters['manager/manager'].authorityKbn;
                // 企業一覧の取得
                await this.$axios
                    .get(this.$apiEndpoint + 'manage/brand')
                    .then(response => (this.companyLists = response['data']['brand']))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);
            },
            sortBy:function(key){
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;
            },
            setStoreId(id) {
                this.$store.dispatch('store/setStoreId', id)
            },
            openModel(id, storeId, storeName){
                this.showContent = true;
                this.delId = id;
                this.delStoreName = storeName;
                this.storeId = storeId;
            },
            closeModel: function(){
                this.showContent = false;
                this.delId = null;
                this.storeName = "";
            },
            async changeCompany(){
                this.isLoading = true;
                //ブランドIDを取得
                this.brandId =this.companySelectValue;
                //会社名とブランド名を取得
                this.companyLists.forEach(company => {
                    if(company.id == this.companySelectValue){
                        this.delCompanyName = company.companyName
                        this.delBrandName = company.brandName
                        return
                    }
                });

                // 管理画面店舗一覧取得API
                await this.$axios
                    .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store')
                    .then(response => (this.storeContent = response['data']['storeList']))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        if (this.auth == 4 && err.customError.code) {
                            //店舗管理者のtokenエラーの場合
                            this.$cookies.set('user-api-token', '', 0)
                            this.$store.dispatch('store/doClear')
                        }
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isLoading = false);
            },
            async canModel() {

                this.ApivalidationMessage = '';
                this.showContent = false;
                this.isLoading = true;

                var apiResponseFlg = true;

                //店舗解約API
                await this.$axios
                    .post(this.$apiEndpoint + 'manage/store/cancellation', {brandId: this.brandId, storeId: this.storeId})
                    .then(response => (this.storeList = response['data']['storeList']))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);
                            if(error.code == 400){
                                this.ApivalidationMessage =  error.message;
                            } else if (error.code == 401) {
                                //店舗管理者のtokenエラーの場合
                                this.$cookies.set('user-api-token', '', 0)
                                this.$store.dispatch('store/doClear')
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);

                if(apiResponseFlg){
                    this.showContent2 = true;
                    this.calc();
                }
            },
            closeModel2() {
                this.showContent2 = false;
                this.delId = null;
                this.delStoreName = "";
                this.changeCompany();
            }
        },
        computed:{
            filteredDatas:function(){
                var data = this.storeContent;
                var sortKey = this.sortKey;
                var order = this.sortOrders[sortKey] || 1;
                if(sortKey){
                    data = data.slice().sort(function(a,b){
                        a = a[sortKey];
                        b = b[sortKey];
                        return(a === b ? 0 : a > b? 1 : -1) * order;
                    });
                }
                var filterWord = this.searchWord && this.searchWord.toLowerCase();
                if(filterWord){
                    data = data.filter(function (row){
                        return Object.keys(row).some(function (){
                            return String(row["storeName"]).toLowerCase().indexOf(filterWord) === 0
                        })
                    })
                }
                return data;
            },
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
        }
    }
</script>